import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import { careerPageTplData } from "../data/page-tpl-career.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import PageHead from "../components/Page/PageHead";
// import Benefits from "../components/Benefits";
import OpenPositions from "../components/OpenPositions";
import ImageSectionsGroupCareer from "../components/ImageSectionsGroupCareer";
import ImageSection from "../components/ImageSection";
import ThreeColumns from "../components/ThreeColumns";
import AccordionSection from "../components/AccordionSection";
import Hero from "../componentsSections/Hero";
import { VectorBackground } from "../components/VectorBackground";
import ContainerWide from "../components/ContainerWide";

const pageCarrer = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = careerPageTplData(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            {/* SEO Metas */}
            <Seo post={seoPageData} />
            {/* Hero */}
            <Hero {...pageData.hero} textSize="big" hideBadges />
            {/* Page head */}
            <Section className="-small-margin-bottom">
                <Container>
                    <PageHead {...pageData.pageHead} />
                </Container>
            </Section>
            {/* Image Sections */}
            <Section className="-mobile-full -small-margin-bottom">
                <ImageSectionsGroupCareer
                    flipped={true}
                    imageSections={pageData.imageSections}
                    centerMobile
                />
            </Section>

            {/* Section ImageSectionsGroup  */}
            <Section className="-small-margin-bottom">
                <div
                    className="color-wrapper container-wide"
                    style={{ position: "relative" }}
                >
                    <VectorBackground gradient />
                    <ImageSection
                        imageSection={pageData.imageSection}
                        flipped={true}
                    />
                </div>
            </Section>

            {/* Resources Section */}
            {/* <Section>
                <Container>
                    <Benefits {...pageData.benefits} images={pageData.images} />
                </Container>
            </Section> */}

            {/* Open Positions Section */}
            <Section className="-no-margin-bottom">
                <Container>
                    <OpenPositions {...pageData.openPositions} />
                </Container>
            </Section>

            <Section>
                <ImageSection
                    imageSection={pageData.textImage.imageSection}
                    centerMobile
                />
            </Section>

            <Section>
                <ContainerWide>
                    <ThreeColumns
                        data={pageData.threeColumns}
                        button={pageData.threeColumnsButton}
                    />
                </ContainerWide>
            </Section>

            {/* Accordion Section */}
            <Section className="-margin-bottom-tiny">
                <div className="color-wrapper color-wrapper--dark-blue container-wide">
                    <AccordionSection {...pageData.accordion} />
                </div>
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default pageCarrer;
